<template>
    <BaseLayoutDefault>
        <NuxtLoadingIndicator />
        <template #aside>
            <TheSidebar />
        </template>
        <slot />
    </BaseLayoutDefault>
</template>
